import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Toggle } from 'core/hoc';

import {
	Content,
	ShowMore,
} from 'core/styles';
import MultilineText from 'core/components/MultiLineText';

const FormattedBody = ({ children, lineBreaks, hasMore, on, toggle, ...rest }) => {
	return (
		<Fragment>
			{!lineBreaks ? (
				<Content {...rest}>{children}</Content>
			) : (
				<Content {...rest}><MultilineText text={children} /></Content>
			)}
			{hasMore && (
				<Content {...rest}>
					<ShowMore onClick={toggle}>
						{on ? 'Show Less' : 'Show More'}
					</ShowMore>
				</Content>
			)}
		</Fragment>
	);
};

FormattedBody.propTypes = {
	children: PropTypes.string.isRequired,
	lineBreaks: PropTypes.bool,
	hasMore: PropTypes.bool,
	on: PropTypes.bool,
	toggle: PropTypes.func,
};


class TruncatedContent extends PureComponent {
	_toggle(on, toggle) {
		toggle();
		this.props.onToggle && this.props.onToggle(!on);
	}

	render () {
		const { children, format, visibleWordCount, ...rest } = this.props;
		const words = children.split(' ');
		const tooManyWords = words.length > visibleWordCount;

		return (
			<Toggle simple>
				{({ on, toggle }) => {
					let body = children;
					if (!on && tooManyWords) {
						body = words.filter((_, i) => i < visibleWordCount).join(' ');
						body = body + '...';
					}

					return (
						<FormattedBody on={on} toggle={() => this._toggle(on, toggle)} lineBreaks={format} hasMore={tooManyWords} {...rest}>
							{body}
						</FormattedBody>
					);
				}}
			</Toggle>
		);
	}
}

TruncatedContent.propTypes = {
	children: PropTypes.string.isRequired,
	visibleWordCount: PropTypes.number,
	format: PropTypes.bool,
	onToggle: PropTypes.func,
};

TruncatedContent.defaultProps = {
	visibleWordCount: 250,
	format: true,
	onToggle: null,
};

export default TruncatedContent;
